import { render, staticRenderFns } from "./NotificationIntroductionPopup.vue?vue&type=template&id=c5e37996&scoped=true"
import script from "./NotificationIntroductionPopup.vue?vue&type=script&lang=js"
export * from "./NotificationIntroductionPopup.vue?vue&type=script&lang=js"
import style0 from "./NotificationIntroductionPopup.vue?vue&type=style&index=0&id=c5e37996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e37996",
  null
  
)

export default component.exports